import { render } from "./CurrentChords.vue?vue&type=template&id=5a0a670b&scoped=true"
import script from "./CurrentChords.vue?vue&type=script&lang=js"
export * from "./CurrentChords.vue?vue&type=script&lang=js"

import "./CurrentChords.vue?vue&type=style&index=0&id=5a0a670b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a0a670b"

export default script